import { isActive } from '../project-model';
import GeneralInfo from '../../components/GeneralInfo';
import styles from './project-payment.module.less';

export const ValidationWrapper = ({ project, paymentEnabled, requiresProject = true, children }) => {
    if (!isActive(project) && requiresProject) {
        return (
            <div className={styles.container}>
                <GeneralInfo info="Det er ikke mulig å betale inn til denne innsamlingen!" />
            </div>
        );
    } else if (!paymentEnabled) {
        return (
            <div className={styles.container}>
                <GeneralInfo info="Betaling er midlertidig skrudd av. Prøv gjerne igjen senere!" />
            </div>
        );
    }
    return <>{children}</>;
};
